export default "__VITE_ASSET__DSaWfnAF__";